module.exports = __webpack_public_path__ + "static/media/money-check.26a71dec.svg";